import { APIS } from '../../utils/apiConfig';
import { createRequestUtility } from '../../utils/httpUtils';
import { HttpService } from '../HttpService/HttpService';

export class CostAnalysisService {
  // constructor(private httpService: HttpService) {}
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  // example for other request
  // async getPlatformBrowserData(params: getPlatformBrowserDataParams): Promise<any> {
  //   return this.makeRequest('get', APIS.GET_PLATFORM_BROSWER_DATA(), { params });
  // }

  // async removeUnusedResource(params: any): Promise<any> {
  //   return this.makeRequest('delete', APIS.UNUSED_REMOVE(), params);
  // }

  // async resizeInstance(params: any): Promise<any> {
  //   return this.makeRequest('patch', APIS.RESIZE_INSTANCE(), params);
  // }

  async getCostUsageReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_COST_USAGE(), params);
  }
  async getCategoryList(params: string): Promise<any> {
    return this.makeRequest('post', APIS.GET_CATEGORY_LIST(), params);
  }
  async downloadCostReport(params: string): Promise<any> {
    return this.makeRequest('post', APIS.DOWNLOAD_COST_REPORT(), params);
  }
}
